import { createAppContext } from '@juvare/platform-sdk-react/AppContext';
import { UserState } from '../backend/app';

export const AppContext = createAppContext<UserState>();
